import * as React from 'react';

import { translate } from '~l10n/client';

import { ViewPricingTableEventAdapter } from '~analytics/adapters/ViewPricingTableEventAdapter';
import { PaywallScreens } from '~analytics/types';
import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation, DialogProps } from '~shared/components/Dialog';

export interface ConfirmationProps
  extends Pick<DialogProps, 'open' | 'onClose'> {
  onDelete: () => void;
}

export function DeleteQuizConfirmation({
  open,
  onClose,
  onDelete,
}: ConfirmationProps) {
  return (
    <DialogConfirmation
      id="confirm-delete"
      open={open}
      title={translate('Please Confirm')}
      onClose={onClose}
      closeLabel={translate('Close')}
      actions={[
        <UIButton key="cancel" onClick={onClose}>
          {translate('Cancel')}
        </UIButton>,
        <UIButton key="delete" appearance="risky" onClick={onDelete}>
          {translate('Delete')}
        </UIButton>,
      ]}
    >
      <span
        onClick={() => {
          new ViewPricingTableEventAdapter({
            source: 'paywall',
            paywall_feature: PaywallScreens.QuizListDeleteQuiz,
          }).sendAnalytics();
        }}
        dangerouslySetInnerHTML={{
          __html: translate(
            'You will not be able to restore it on the free plan. {0}Upgrade to Socrative Pro{1} now or later to restore deleted quizzes.'
          ).format(
            '<a class="font-500 text-cyan-700 no-underline hocus:text-cyan-600 hover:underline focus:underline rounded-2 transition ease-in-out duration-150" href="/teacher/#pricing">',
            '</a>'
          ),
        }}
      />
    </DialogConfirmation>
  );
}
